<!-- If in a buttonsOnly view, just display #buttons template -->
<ng-container *ngIf="buttonsOnly; then buttons else standardOrMobileView">

</ng-container>

<!-- If in a mobile view, display a button to open the action buttons in a bottom sheet -->
<ng-template #standardOrMobileView>
  <ng-container *ngIf="isMobileView; then mobileActionButton else standardView">

  </ng-container>
</ng-template>

<ng-template #mobileActionButton>
  <button class="btn mb-0100"
          (click)="openInBottomSheet(buttons)"
          *ngIf="isMobileView">Actions
    <i class="far fa-ellipsis-v spacerLeft"></i>
  </button>
</ng-template>

<ng-template #standardView>
  <div class="table vert-0100">

    <div class="tr tr--noGutter tile__heading"
         style="border-bottom: 1px solid #DDE0EB;">
      <span>Actions</span>
    </div>

    <ng-container *ngTemplateOutlet="buttons"></ng-container>
  </div>
</ng-template>

<ng-template #buttons>
  <mat-action-list dense
                   class="actions__mat-action-list pb-0025">
    <button mat-list-item
            (click)="openAssessmentDialog()">
      <mat-icon fontSet="fal fa-fw"
                fontIcon="fa-sliders-h"
                matListIcon></mat-icon>
      <span matLine>New Assessment</span>
    </button>
    <button mat-list-item
            type="button"
            *ngIf="addContactEnabled"
            [matTooltip]="addContactTooltip"
            (click)="openAddContactDialog()">
      <mat-icon fontSet="fal fa-fw"
                fontIcon="fa-comments-question"
                matListIcon></mat-icon>
      <span matLine>Log Conversation</span>
    </button>
    <button mat-list-item
            type="button"
            (click)="openAddFieldsDialog()">
      <mat-icon fontSet="fal fa-fw"
                fontIcon="fa-tag"
                matListIcon></mat-icon>
      <span matLine>Add Info</span>
    </button>
    <button mat-list-item
            type="button"
            *ngIf="campaignHasConnections"
            (click)="openAddConnectionDialog()">
      <mat-icon fontSet="fal fa-fw"
                fontIcon="fa-share-alt"
                matListIcon></mat-icon>
      <span matLine>Add Connection</span>
    </button>
    <ng-container>
      <button *ngIf="showMerge"
              type="button"
              mat-list-item
              (click)="openMergeEntitiesDialog()">
        <mat-icon fontSet="fal fa-fw"
                  fontIcon="fa-code-merge"
                  matListIcon></mat-icon>
        <span matLine>Merge</span>
      </button>
      <button *ngIf="!showMerge"
              mat-list-item
              (click)="openQuickEditDialog()">
        <mat-icon fontSet="fal fa-fw"
                  fontIcon="fa-pen-to-square"
                  matListIcon></mat-icon>
        <span matLine>Quick Edit</span>
      </button>
    </ng-container>
    <button mat-list-item
            *ngIf="showRemove"
            (click)="onRemoveFromCampaignClicked()"
            class="color--red--003">
      <mat-icon fontSet="fal fa-fw"
                fontIcon="fa-user-times"
                matListIcon></mat-icon>
      <span matLine>Remove From Campaign</span>
    </button>
  </mat-action-list>

</ng-template>
